export default {
    availability_title: {
        label: 'Название расписания',
        placeholder: 'Введите название расписания.. Можно использовать имя ответственного за него.',
        tool_tip_message: 'Введите название расписания.. Можно использовать имя ответственного за него.',
    },

    booking_days_limit: {
        label: 'Разрешить бронирование за дней',
        placeholder: 'Введите число',
        tool_tip_message: 'Максимальное количество дней, на которые пользователи могут бронировать слоты заранее.',
    },

    user_availability: {
        users: 'Пользователи компании',
        new_users: 'Новые пользователи',
        admin: 'Администратор',
        performer: 'Исполнитель',
        add_user: '+ Добавить пользователя',
    },
    user_modal: {
        invite_user: 'Хотите пригласить пользователя?',
        found_user: 'Найден пользователь',
        user_email_not_found: 'Пользователь с email:',
        user_email_not_found_1: 'не существует. Хотите пригласить пользователя?',
        user_list: 'Список пользователей:',
    },
    errors: {
        user_in_company:
            'Выбранный пользователь уже состоит в компании. Чтобы добавить пользователя, перейдите на вкладку Пользователи компании!',
        user_already_added: 'Выбранный пользователь уже добавлен!',
    },
    modal: {
        heading: 'Вы хотите применить выбранные слоты на несколько дней?',
        heading_days: 'Выберите дни, на которые вы хотите применить выбранные слоты.',
    },
}
